import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { selectModalBulkUpdateField, selectVulnsSelected } from 'store/ManageGeneral/selectors';
import {
  Wrapper, Icon, Title
} from './styled';

const BulkTitle = () => {
  const vulnsSelected = useSelector(selectVulnsSelected);
  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const selectedVulnsCount = vulnsSelected.length;

  const getTitle = () => {
    if (bulkUpdateField === 'name') return 'vulns.edit.title.name';
    else if (selectedVulnsCount > 1) return 'vulns.edit.bulkTitle';
    else return 'vulns.edit.title';
  };

  const title = getTitle();

  return (
    <Wrapper isBulk={ selectedVulnsCount > 1 }>
      <Icon />
      <Title>
        <FormattedMessage id={ title } />
      </Title>
    </Wrapper>
  );
};

export default BulkTitle;
